export const ADD_KEYWORDS_BY_ENTRY = 'entry';
export const ADD_KEYWORDS_BY_SELECTION = 'select';
